export const CERTIFICATE_MAX_BYTES = 50 * 1024 * 1024;
export const CERTIFICATE_ACCEPT = '.jpg,.jpeg,.png,.gif,image/jpeg,image/png,image/gif';

const ALLOWED_EXTENSIONS = new Set(['jpg', 'jpeg', 'png', 'gif']);
const ALLOWED_MIME_TYPES = new Set(['image/jpeg', 'image/pjpeg', 'image/png', 'image/gif']);

const extensionOf = (name = '') => name.includes('.') ? name.split('.').pop().toLowerCase() : '';

const sniffImageType = async (file) => {
  const bytes = new Uint8Array(await file.slice(0, 16).arrayBuffer());

  if (bytes[0] === 0xff && bytes[1] === 0xd8 && bytes[2] === 0xff) return 'jpeg';
  if (bytes.length >= 8 && bytes[0] === 0x89 && bytes[1] === 0x50 && bytes[2] === 0x4e && bytes[3] === 0x47
    && bytes[4] === 0x0d && bytes[5] === 0x0a && bytes[6] === 0x1a && bytes[7] === 0x0a) return 'png';

  const header = String.fromCharCode(...bytes);
  if (header.startsWith('GIF87a') || header.startsWith('GIF89a')) return 'gif';

  // ISO-BMFF brands used by HEIC/HEIF. Renaming such a file to .jpg does not convert it.
  const brand = header.slice(4, 12);
  if (brand.startsWith('ftyp') && /(heic|heix|hevc|hevx|heim|heis|mif1|msf1)/.test(brand)) return 'heic';

  return null;
};

export async function validateCertificateImage(file) {
  if (!(file instanceof File)) {
    return { valid: false, message: 'برجاء اختيار ملف صورة صالح.' };
  }

  if (file.size > CERTIFICATE_MAX_BYTES) {
    return { valid: false, message: 'يجب ألا يتجاوز حجم صورة الشهادة 50 ميجابايت.' };
  }

  const extension = extensionOf(file.name);
  if (!ALLOWED_EXTENSIONS.has(extension)) {
    return { valid: false, message: 'امتداد الملف يجب أن يكون JPG أو JPEG أو PNG أو GIF.' };
  }

  if (file.type && !ALLOWED_MIME_TYPES.has(file.type.toLowerCase())) {
    return { valid: false, message: 'نوع الملف غير مدعوم. استخدم JPG أو JPEG أو PNG أو GIF.' };
  }

  const detectedType = await sniffImageType(file);
  if (detectedType === 'heic') {
    return { valid: false, message: 'الملف HEIC/HEIF وليس JPG حقيقياً. برجاء تحويل الصورة إلى JPG أو PNG ثم رفعها.' };
  }

  const expectedType = extension === 'jpg' || extension === 'jpeg' ? 'jpeg' : extension;
  if (!detectedType || detectedType !== expectedType) {
    return { valid: false, message: 'محتوى الملف لا يطابق امتداده. برجاء رفع صورة JPG أو JPEG أو PNG أو GIF حقيقية.' };
  }

  return { valid: true };
}

export function certificateUploadError(error) {
  if (error?.response?.status === 413) {
    return 'حجم طلب الرفع أكبر من الحد المسموح. الحد الأقصى لصورة الشهادة 50 ميجابايت.';
  }

  const certificateErrors = error?.response?.data?.errors?.certificate_image;
  if (Array.isArray(certificateErrors) && certificateErrors.length) return certificateErrors[0];

  return error?.response?.data?.message || 'حدث خطأ أثناء إرسال البيانات';
}

export function revokeCertificatePreview(url) {
  if (typeof url === 'string' && url.startsWith('blob:')) URL.revokeObjectURL(url);
}
